import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { FirebaseService } from '@app-services/firebase/firebase.service';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { UserService } from '@app-services/user/user.service';
import { environment } from '@app-environments/environment';

@Component({
  selector: 'app-story-card',
  templateUrl: './story-card.component.html',
  styleUrls: ['./story-card.component.css'],
  providers: [CookieService]
})
export class StoryCardComponent implements OnInit {
  @Input() story:any;
  storyData: any;
  userData: any;
  constructor(public selfLearnService: SelfLearnService,    private sanitizer: DomSanitizer,
    private cookieService: CookieService,public spinner:NgxSpinnerService,private firebaseService: FirebaseService,  private userService: UserService,) { }

  ngOnInit(): void {
    this.userData = JSON.parse(
      localStorage.getItem(apisDataCacheKeys.userDetails)
    );
  }
  updateStoryProgress(){
    let paylaod:any = {
      "examId": this.selfLearnService.getCmsExamID(),
      "gradeId": this.selfLearnService.getGradeId(),
      "subjectId": this.selfLearnService.getSubjectId(),
      "chapterId": this.selfLearnService.getChapterId(),
      "chapterName": this.selfLearnService.getChapterName(),
      "storyId": this.story.storyId,
      "timeTakenInSec": 0,
    }
    this.selfLearnService.updateStoryProgress(paylaod).subscribe((res:any) => {
    
    })
  }
  openStory(){
    if(this.selfLearnService.isFromLearn()){
      this.sendLsqData()
    };
    this.updateStoryProgress();
    this.spinner.show();
    this.selfLearnService.getStoryWithCMSAPI(this.story.storyId).subscribe((response:any) => {
      if (response) {
        this.storyData = response?.data;
        this.storyData.storyURL = this.transform(
          this.storyData.storyURL
        );
        let keyPairId =  response?.data?.keyPairId;
        let signature =  response?.data?.signature;
        let policy =  response?.data?.policy;
        const origin = response?.data.storyURL.toString();
        const tempDomain = `.${origin.split('.')?.[1]}.${origin.split('.')?.[2]}`;
        const domain = tempDomain.split('/')[0];
        console.log(domain);
        // this.cookieService.deleteAll('/',domain);
        // this.cookieService.delete("CloudFront-Policy","/",domain,true,"None");
        // this.cookieService.delete("CloudFront-Signature","/",domain,true,"None");
        // this.cookieService.delete("CloudFront-Key-Pair-Id","/",domain,true,"None");

        this.cookieService.set(
          'CloudFront-Policy',
          policy,
          undefined,
          '/',
          domain,
          false,
          null
        );
        this.cookieService.set(
          'CloudFront-Signature',
          signature,
          undefined,
          '/',
          domain,
          false,
          null
        );
        this.cookieService.set(
          'CloudFront-Key-Pair-Id',
          keyPairId,
          undefined,
          '/',
          domain,
          false,
          null
        );
        setTimeout(() => {
          window.open(this.storyData.storyURL.changingThisBreaksApplicationSecurity, "_blank");
          this.spinner.hide();
        }, 1000);
      }


    })

  }
    transform(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  sendLsqData(){
   let payload={
      data:{
      "story_subject" : this.selfLearnService.getSubjectName(),
      "story_chapter" : this.selfLearnService.getChapterName()
    },
    landingPage : "LSQ_CUSTOM_EVENTS"
    };
    let firebasePayload = {
      "ActivityDateTime": moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      "ActivityEvent": 265,
      "Fields":{},
      "FirstName": this.userData?.firstName,
      "LastName": this.userData?.lastName,
      "environment": environment?.branch,
      "phone": this.userData?.phone,
      "productId": 1,
      "type": "Activity"
    }
    // this.selfLearnService.callTrackingAPI2(payload,'Act_Self_Learn_Story').subscribe((data)=>{console.log(data);
    // });

    this.firebaseService.getSqsValue().then((firebaseRSP) => {
      firebasePayload.Fields = {
        "mx_Custom_1" : this.selfLearnService.getSubjectName(),
        "mx_Custom_2" : this.selfLearnService.getChapterName()
      }
      this.userService.sendSQSMsg(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,firebasePayload);
    }).catch((e) => {
      console.log(e);
    });
  }

}
